type TokenKey = 'access_token' | 'id_token' | 'refresh_token' | 'pkce_verifier' | 'oauth_proxy_state';

const getToken = (key: TokenKey): string | null => sessionStorage.getItem(key);

const setToken = (key: TokenKey, value: string): void => {
  sessionStorage.setItem(key, value);
};

const removeToken = (key: TokenKey): void => {
  sessionStorage.removeItem(key);
};

const clearAllTokens = (): void => {
  removeToken('access_token');
  removeToken('id_token');
  removeToken('refresh_token');
  removeToken('pkce_verifier');
  removeToken('oauth_proxy_state');
};

const isAuthenticated = (): boolean => getToken('access_token') !== null;

export { getToken, setToken, removeToken, clearAllTokens, isAuthenticated };
export type { TokenKey };
